import { type ReactNode } from "react";
import { useField } from "formik";

import {
  RadioGroup,
  type RadioItemProps,
} from "@vega-core/components/Form/Controls/Radio/RadioGroupField/RadioGroupField";
import { isTruthy } from "@vega-core/utils/isTruthy";

type Props = {
  isOptional?: boolean;
  labelVariant?: "compact" | "default" | "transparent";
  items: RadioItemProps[];
  label?: ReactNode | string;
  labelHint?: ReactNode | string;
  labelTag?: ReactNode;
  name: string;
  variant?: "horizontal" | "vertical";
  withBorders?: boolean;
  tooltipContentClassname?: string;
  fullWidth?: boolean;
};

export function RadioGroupField({
  isOptional,
  items,
  label,
  labelHint,
  labelTag,
  labelVariant,
  name,
  variant,
  tooltipContentClassname,
  fullWidth,
}: Props) {
  const [field, meta, helpers] = useField(name);

  return (
    <RadioGroup
      error={meta.touched && isTruthy(meta.error) ? meta.error : undefined}
      fullWidth={fullWidth}
      isInlineList={variant === "horizontal"}
      isOptional={isOptional}
      items={items}
      labelHint={labelHint}
      labelTag={labelTag}
      labelVariant={labelVariant}
      name={name}
      onBlur={field.onBlur}
      setChange={(value, checked) => {
        helpers.setValue(checked && isOptional ? undefined : value);
      }}
      showDescriptions
      title={label}
      tooltipContentClassname={tooltipContentClassname}
      value={isTruthy(field.value) ? field.value.toString() : undefined}
    />
  );
}
